export function cleanInstagramPostURL(url) {
    // Vérifiez que l'URL est fournie et n'est pas une chaîne vide
    if (!url) {
       return '#';
    }

    let cleanedUrl;

    // Essayez de créer un objet URL pour valider le format de l'URL
    try {
        cleanedUrl = new URL(url);
    } catch (error) {
      console.log(error);
      return '#';
    }

    return `${cleanedUrl.protocol}//${cleanedUrl.host}${cleanedUrl.pathname}`;
}